{
  "opensInNewTab": " opens in new tab"
}
